var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMtnLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 34,
    viewBox: "0 0 69 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.1731 0.182922C15.2999 0.182922 0 7.74502 0 17.073C0 26.4011 15.2999 33.963 34.1731 33.963C53.0462 33.963 68.3462 26.4009 68.3462 17.073C68.3462 7.74488 53.0462 0.182922 34.1731 0.182922ZM34.1731 31.2966C16.7896 31.2966 2.6976 24.9285 2.6976 17.073C2.6976 9.21745 16.7898 2.84938 34.1731 2.84938C51.5565 2.84938 65.6486 9.21745 65.6486 17.073C65.6486 24.9285 51.5564 31.2966 34.1731 31.2966ZM29.8635 14.1098V11.4428H39.5041V14.1098H36.0333V22.7031H33.3348V14.1098H29.8635ZM51.141 11.4428V22.7033H48.4435L43.5508 16V22.7033H40.8532V11.4428H43.5507L48.4434 18.1461V11.4428H51.141ZM17.1249 22.7033V11.4428H19.8225L22.8195 16L25.8166 11.4428H28.5131V22.7033H25.8166V16.3341L23.7705 19.443H21.8685L19.8225 16.3341V22.7033H17.1249Z",
    fill: "#071B2B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMtnLogo);
export default __webpack_public_path__ + "static/media/MTN_Logo.e7b6852c.svg";
export { ForwardRef as ReactComponent };